import { render } from "./Forget.vue?vue&type=template&id=54b9e950&scoped=true"
import script from "./Forget.vue?vue&type=script&lang=js"
export * from "./Forget.vue?vue&type=script&lang=js"

import "./Forget.vue?vue&type=style&index=0&id=54b9e950&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-54b9e950"

export default script